import React, { useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import * as Utils from '../../commons/utils/Utils';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Radio,
  FormControlLabel,
  RadioGroup
} from '@material-ui/core';
import { StyledTableCell } from '../../commons/utils/TableStyles';
import Timezone from '../../commons/timezone/Timezone.js';
import { StyledTooltip } from '../../commons/utils/TableStyles';
import $ from 'jquery';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import LocaleFormat from '../../commons/utils/LocaleFormat.js';

const HistoricoDatosGeneralesGrid = (props) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [radioValue, setRadioValue] = useState('estado');
  const [estados,setEstados] = useState(null);
  const [bases,setBases] = useState(null);
  const [dominios,setDominios] = useState(null);
  const [unidades,setUnidades] = useState(null);
  const [gerenciadores,setGerenciadores] = useState(null);
  const [responsables,setResponsables] = useState(null);
  const [reservas,setReservas] = useState(null);
  const [rutas,setRutas] = useState(null);
  const [erpMods,setErpMods] = useState(null);

  const handleChangeRadio = (event) => {
    setRadioValue(event.target.value)
  }

  const handleExport = () => {
    let data = null;
    switch (radioValue) {
      case 'estado':
        data = estados;
        break;
      case 'base':
        data = bases;
        break;
      case 'dominio':
        data = dominios;
        break;
      case 'unidad':
        data = unidades;
        break;
      case 'gerenciador':
        data = gerenciadores;
        break;
      case 'responsable':
        data = responsables;
        break;
      case 'reserva':
        data = reservas;
        break;
      case 'ruta':
        data = rutas;
        break;
      case 'erpMod':
        data = erpMods;
        break;
      default:
        break;
    }

    let auxDataToExport = JSON.stringify({
      dataToExport: data,
      entidad: radioValue
    })

    Utils.sendDataBlob('/moviles/exportar-historico-datos-generales','POST',auxDataToExport)
      .then((data) => {
        let fileBlob = new File([data],'historico-datos-generales.xlsx')
        let fileUrl = URL.createObjectURL(fileBlob);
        $("<a />", {
          href: fileUrl,
          download: "historico-datos-generales.xlsx"
        }).appendTo("body").get(0).click();
      })
      .catch(() => {
			})
	}
  
  useEffect(() => {
    setLoading(true)
    Utils.getData(`/moviles/historico-datos-generales-grid/${props.movilId}`)
      .then((res) => {
        setEstados(res.estados)
        setBases(res.bases)
        setDominios(res.dominios)
        setUnidades(res.unidades)
        setGerenciadores(res.gerenciadores)
        setResponsables(res.responsables)
        setReservas(res.reservas)
        setErpMods(res.erpMods)
        let rutas = [];
        res.rutas.map(ruta => {
          let labelRutasOrigenCompleto = "";
          let labelRutasDestinoCompleto = "";
          if(ruta.rutas_origen){
            let idsOrigen = JSON.parse(ruta.origen_movil_rutas);
            let idsDestino = JSON.parse(ruta.destino_movil_rutas);

            let rutasOrigen = JSON.parse(ruta.rutas_origen).filter(r => idsOrigen.includes(r.id));
            let rutasDestino = JSON.parse(ruta.rutas_destino).filter(r => idsDestino.includes(r.id));
            
            rutasOrigen = rutasOrigen.filter(
              (ruta, index, self) => index === self.findIndex(r => r.id === ruta.id)
            );
            rutasDestino = rutasDestino.filter(
              (ruta, index, self) => index === self.findIndex(r => r.id === ruta.id)
            );

            labelRutasOrigenCompleto = rutasOrigen.map(r => {
              return (r.baseDescripcion ? r.baseDescripcion.substring(0, 4) : '') + (r.nombre ? r.nombre : '') + (r.tipoRuta ? r.tipoRuta : '');
            }).join(", ");

            labelRutasDestinoCompleto = rutasDestino.map(r => {
              return (r.baseDescripcion ? r.baseDescripcion.substring(0, 4) : '') + (r.nombre ? r.nombre : '') + (r.tipoRuta ? r.tipoRuta : '');
            }).join(", ");

          }

          rutas.push({
            ...ruta,
            labelRutasOrigenCompleto: labelRutasOrigenCompleto,
            labelRutasDestinoCompleto: labelRutasDestinoCompleto
          });
        });
        setRutas(rutas)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false);
      });

  },[])

  return (
    <div className="card">
      <div className="card-content">
        <div className="card-body">
          <div className="container-fluid mb-1">
            <div className="row dt-icons">
              <div className="col-md-11">
                <RadioGroup row value={radioValue} onChange={handleChangeRadio}>
                  <FormControlLabel
                    value="estado"
                    label={<FormattedMessage id="movilesAbm.datosGenerales_modal.radio.estado.label" defaultMessage="Estado" />}
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="base"
                    label={<FormattedMessage id="movilesAbm.datosGenerales_modal.radio.base.label" defaultMessage="Base" />}
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="dominio"
                    label={<FormattedMessage id="moviles.dominio" defaultMessage="Dominio" />}
                    control={<Radio color="default" />}
                  />
                  <FormControlLabel
                    value="unidad"
                    label={<FormattedMessage id="moviles.unidad" defaultMessage="Unidad" />}
                    control={<Radio color="default" />}
                  />
                  {ConfigBusiness.get('moviles.gerenciador.asignacionManual') === 'true' ?
                    <FormControlLabel
                      value="gerenciador"
                      label={<FormattedMessage id="moviles.gerenciador" defaultMessage="Gerenciador" />}
                      control={<Radio color="default" />}
                    />
                  : ''}
                  {ConfigBusiness.get('moviles.responsableBase.asignacionManual') === 'true' ?
                    <FormControlLabel
                      value="responsable"
                      label={<FormattedMessage id="moviles.responsableBase" defaultMessage="Responsable de Base" />}
                      control={<Radio color="default" />}
                    />
                  : ''}
                  {ConfigBusiness.get('moviles.movil_reserva.habilitado') === 'true' ?
                    <FormControlLabel
                      value="reserva"
                      label={<FormattedMessage id="moviles.Reserva" defaultMessage="Reserva" />}
                      control={<Radio color="default" />}
                    />
                  : ''}
                  {ConfigBusiness.get('moviles.ruta.grilla') === 'true' ?
                    <FormControlLabel
                      value="ruta"
                      label={<FormattedMessage id="moviles.Ruta" defaultMessage="Ruta" />}
                      control={<Radio color="default" />}
                    />
                  : ''}
                  <FormControlLabel
                    value="erpMod"
                    label={<FormattedMessage id="moviles.erpMod" defaultMessage="Últ. Act. ERP" />}
                    control={<Radio color="default" />}
                  />
                </RadioGroup>
              </div>
              <div className="col-md-1">
                <div style={{marginLeft:"85px"}}>
                  <StyledTooltip
                    title={intl.formatMessage({
                      id: 'movilesAbm.datosGenerales_modal.tools_export.title_exportar_a_excel',
                      defaultMessage: 'Exportar a Excel',
                    })}
                    arrow
                    placement="top"
                  >
                    <button onClick={()=>handleExport()} className="btn" type="button">
                      <span>
                        <i className="ft-upload"></i>
                      </span>
                    </button>
                  </StyledTooltip>
                </div>
              </div>
            </div>
          </div>
          {/* Historico Estados */}
          {radioValue === 'estado' && 
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_dominio.label" defaultMessage="Dominio" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="HistoricoDatosGeneralesGrid.datosGenerales_modal.column_unidad.label" defaultMessage="Unidad" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_fecha.label" defaultMessage="Fecha y Hora" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_estado_origen.label" defaultMessage="Estado Origen" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_estado_destino.label" defaultMessage="Estado Destino" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_estado_erp_origen.label" defaultMessage="Estado ERP Origen" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_estado_erp_destino.label" defaultMessage="Estado ERP Destino" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.motivo.label" defaultMessage="Motivo" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_usuario_persona.label" defaultMessage="Persona Modificación" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_ID_del_ticket" defaultMessage="ID del ticket" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                      />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading &&
                  (estados && estados.map((estado,key) => (
                      <TableRow key={key}>
                        <StyledTableCell align="left">{estado.dominio}</StyledTableCell>
                        <StyledTableCell align="left">{estado.unidad}</StyledTableCell>
                        <StyledTableCell align="left">{LocaleFormat.formatDateTime(Timezone.getDateForClient(estado.fecha_hora))}</StyledTableCell>
                        <StyledTableCell align="left">{estado.estado_origen}</StyledTableCell>
                        <StyledTableCell align="left">{estado.estado_destino}</StyledTableCell>
                        <StyledTableCell align="left">{estado.estado_erp_origen}</StyledTableCell>
                        <StyledTableCell align="left">{estado.estado_erp_destino}</StyledTableCell>
                        <StyledTableCell align="left">
                          {estado.motivo === 'cron.cambioEstadoPorRuta'
                            ? <FormattedMessage id="cron.cambioEstadoPorRuta" defaultMessage="Rota realizada" />
                            : estado.motivo}
                        </StyledTableCell>
                        <StyledTableCell align="left">{estado.persona_nya}</StyledTableCell>
                        <StyledTableCell align="left">{estado.ticket_id}</StyledTableCell>
                      </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {/* Historico Bases */}
          {radioValue === 'base' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_dominio.label" defaultMessage="Dominio" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_fecha.label" defaultMessage="Fecha y Hora" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_base_origen.label" defaultMessage="Base Origen" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_base_destino.label" defaultMessage="Base Destino" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="movilesAbm.datosGenerales_modal.column_usuario_persona.label" defaultMessage="Persona Modificación" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (bases && bases.map((base,key) => (
                    <TableRow key={key}>
                      <StyledTableCell align="left">{base.dominio}</StyledTableCell>
                      <StyledTableCell align="left">{LocaleFormat.formatDateTime(Timezone.getDateForClient(base.fecha_hora))}</StyledTableCell>
                      <StyledTableCell align="left">{base.base_origen}</StyledTableCell>
                      <StyledTableCell align="left">{base.base_destino}</StyledTableCell>
                      <StyledTableCell align="left">{base.persona_nya}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {/* Historico Dominios */}
          {radioValue === 'dominio' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Fecha" defaultMessage="Fecha" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehículo_origen" defaultMessage="Vehículo origen" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehículo_destino" defaultMessage="Vehículo destino" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Persona_modificación" defaultMessage="Persona modificación" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Razón_de_cambio" defaultMessage="Razón de cambio" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Comentario" defaultMessage="Comentario" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (dominios && dominios.map((dominio,key) => (
                    <TableRow key={key}>
                      <StyledTableCell align="left">{dominio.fecha}</StyledTableCell>
                      <StyledTableCell align="left">{dominio.dominio_origen}</StyledTableCell>
                      <StyledTableCell align="left">{dominio.dominio_destino}</StyledTableCell>
                      <StyledTableCell align="left">{dominio.fullname}</StyledTableCell>
                      <StyledTableCell align="left">{dominio.razon}</StyledTableCell>
                      <StyledTableCell align="left">{dominio.comentario}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {/* Historico Unidades */}
          {radioValue === 'unidad' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Fecha" defaultMessage="Fecha" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehículo_origen" defaultMessage="Vehículo origen" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehículo_destino" defaultMessage="Vehículo destino" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Persona_modificación" defaultMessage="Persona modificación" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Razón_de_cambio" defaultMessage="Razón de cambio" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Comentario" defaultMessage="Comentario" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (unidades && unidades.map((unidad,key) => (
                    <TableRow key={key}>
                      <StyledTableCell align="left">{unidad.fecha}</StyledTableCell>
                      <StyledTableCell align="left">{unidad.unidad_origen}</StyledTableCell>
                      <StyledTableCell align="left">{unidad.unidad_destino}</StyledTableCell>
                      <StyledTableCell align="left">{unidad.fullname}</StyledTableCell>
                      <StyledTableCell align="left">{unidad.razon}</StyledTableCell>
                      <StyledTableCell align="left">{unidad.comentario}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {radioValue === 'gerenciador' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Fecha" defaultMessage="Fecha" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehiculo_gerenciador_anterior" defaultMessage="Gerenciador anterior" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehiculo_gerenciador_nuevo" defaultMessage="Gerenciador nuevo" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Persona_modificación" defaultMessage="Persona modificación" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (gerenciadores && gerenciadores.map((gerenciador, i) => (
                    <TableRow key={`gerenciador${i}`}>
                      <StyledTableCell align="left">{gerenciador.fecha_cambio}</StyledTableCell>
                      <StyledTableCell align="left">{gerenciador.gerenciador_anterior ? gerenciador.gerenciador_anterior : 'Sin Asignar'}</StyledTableCell>
                      <StyledTableCell align="left">{gerenciador.gerenciador_nuevo ? gerenciador.gerenciador_nuevo : 'Sin Asignar'}</StyledTableCell>
                      <StyledTableCell align="left">{gerenciador.usuario_modificacion}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {radioValue === 'responsable' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Fecha" defaultMessage="Fecha" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehiculo_responsableBase_anterior" defaultMessage="Responsable Base anterior" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Vehiculo_responsableBase_nuevo" defaultMessage="Responsable Base nuevo" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Persona_modificación" defaultMessage="Persona modificación" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (responsables && responsables.map((responsable, i) => (
                    <TableRow key={`responsable${i}`}>
                      <StyledTableCell align="left">{responsable.fecha_cambio}</StyledTableCell>
                      <StyledTableCell align="left">{responsable.responsable_anterior ? responsable.responsable_anterior : 'Sin asignar'}</StyledTableCell>
                      <StyledTableCell align="left">{responsable.responsable_nuevo ? responsable.responsable_nuevo : 'Sin asignar'}</StyledTableCell>
                      <StyledTableCell align="left">{responsable.usuario_modificacion}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {radioValue === 'reserva' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Fecha_y_Hora" defaultMessage="Fecha y Hora" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="reserva_origen" defaultMessage="Vehículo reserva origen" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="reserva_destino" defaultMessage="Vehículo reserva destino" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Persona_modificación" defaultMessage="Persona modificación" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (reservas && reservas.map((reserva,key) => (
                    <TableRow key={key}>
                      <StyledTableCell align="left">{reserva.fecha}</StyledTableCell>
                      <StyledTableCell align="left">{reserva.reserva_origen}</StyledTableCell>
                      <StyledTableCell align="left">{reserva.reserva_destino}</StyledTableCell>
                      <StyledTableCell align="left">{reserva.fullname}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {radioValue === 'ruta' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Fecha_y_Hora" defaultMessage="Fecha y Hora" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="rutas_origen" defaultMessage="Rutas Origen" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="rutas_destino" defaultMessage="Rutas Destino" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Persona_modificación" defaultMessage="Persona modificación" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (rutas && rutas.map((ruta,key) => (
                    <TableRow key={key}>
                      <StyledTableCell align="left">{ruta.fecha}</StyledTableCell>
                      <StyledTableCell align="left">{ruta.labelRutasOrigenCompleto}</StyledTableCell>
                      <StyledTableCell align="left">{ruta.labelRutasDestinoCompleto}</StyledTableCell>
                      <StyledTableCell align="left">{ruta.fullname}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
          {/* Historico ERP Modificaciones */}
          {radioValue === 'erpMod' &&
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="Fecha" defaultMessage="Fecha" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {loading && (
                  <TableRow>
                    <StyledTableCell colSpan={4} align="center">
                      <FormattedMessage
                        id="Cargando"
                        defaultMessage="Cargando"
                       />
                    </StyledTableCell>
                  </TableRow>
                )}
                {!loading && 
                  (erpMods && erpMods.map((erpMod,key) => (
                    <TableRow key={key}>
                      <StyledTableCell align="left">{erpMod.created_at}</StyledTableCell>
                    </TableRow>
                    )
                  ))
                }
                </TableBody>
              </Table>
            </TableContainer>
          }
        </div>
      </div>
    </div>
  )
}
export default HistoricoDatosGeneralesGrid